import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { css } from "glamor";
import { colors } from "../../styles";

interface InfoTooltipProps {
  text: string;
}

export const InfoTooltip = ({ text }: InfoTooltipProps) => {
  const [isTriggerHovered, setIsTriggerHovered] = useState(false);
  const [isTooltipHovered, setIsTooltipHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement | null>(null);

  const isVisible = isTriggerHovered || isTooltipHovered;

  const updatePosition = () => {
    if (!triggerRef.current || typeof window === "undefined") return;

    const rect = triggerRef.current.getBoundingClientRect();
    const tooltipWidth = 260;
    const viewportPadding = 8;

    const top = rect.bottom + 8;
    let left = rect.left;

    const maxLeft = window.innerWidth - tooltipWidth - viewportPadding;
    if (left > maxLeft) {
      left = Math.max(viewportPadding, maxLeft);
    }
    if (left < viewportPadding) {
      left = viewportPadding;
    }

    setPosition({ top, left });
  };

  useEffect(() => {
    if (!isVisible || typeof window === "undefined") return;

    updatePosition();

    const handleResize = () => updatePosition();
    const handleScroll = () => updatePosition();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isVisible]);

  return (
    <div
      ref={triggerRef}
      {...css({
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "help",
      })}
      onMouseEnter={() => setIsTriggerHovered(true)}
      onMouseLeave={() => setIsTriggerHovered(false)}
    >
      <span
        {...css({
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: `1px solid ${colors.ff}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          color: colors.ff,
          background: "white",
        })}
      >
        i
      </span>
      {isVisible &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            {...css({
              position: "fixed",
              top: position.top,
              left: position.left,
              width: 260,
              minWidth: 180,
              background: "rgba(255, 255, 255, 0.90)",
              color: "#333",
              padding: "8px 10px",
              borderRadius: 8,
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)",
              border: "1px solid #E2E2E2",
              fontSize: 12,
              lineHeight: 1.4,
              zIndex: 1000,
            })}
            onMouseEnter={() => setIsTooltipHovered(true)}
            onMouseLeave={() => setIsTooltipHovered(false)}
          >
            {text}
          </div>,
          document.body
        )}
    </div>
  );
};

